<div class="row mb-4 mt-2">
  <div class="col-md-4 mt-2">
    <div class="caption">Данные</div>
  </div>
  <div class="col-md-8">
    <button class="button pull-right mt-2 mr-2" (click)="onProcsRefresh()" title="Перезаписать данные по процентам и долям
вознаграждений всех квартир всех проектов
этого импорта на значения во вкладке Реализация">
      @if (now_in_update_procs !== true) {
        Перезаписать %
      } @else {
        <i class="fa fa-spinner fa-spin"></i> пожалуйста, подождите...
      }
    </button>
    <button class="button pull-right mt-2 mr-2" (click)="onPriceRefresh()" title="Перезаписать все цены на импортные">
      @if (now_in_update_prices !== true) {
        Перезаписать цены
      } @else {
        <i class="fa fa-spinner fa-spin"></i> пожалуйста, подождите...
      }
    </button>
    <button class="button pull-right mt-2 mr-2" (click)="onPlansRefresh()" title="Сбросить обработанные импортом
планировки, чтобы они заново обработались
при следующем запуске импорта. При следующем
запуске данного импорта, планировочные
решения будут загружаться только на помещения
с отсутствующими соответствующими планировками.">
      @if (now_in_update_plans !== true) {
        Сбросить планировки
      } @else {
        <i class="fa fa-spinner fa-spin"></i> пожалуйста, подождите...
      }
    </button>
    <button class="button pull-right mt-2 mr-2" (click)="onStatusRefresh()" title="Перезаписать все статусы связанных
помещений импорта в соответствии с соответствующим статусом внутри фида">
      @if (now_in_update_statuses !== true) {
        Перезаписать статусы
      } @else {
        <i class="fa fa-spinner fa-spin"></i> пожалуйста, подождите...
      }
    </button>
  </div>
</div>
<ng-template #prices_updating>
  <i class="fa fa-spinner fa-spin"></i> пожалуйста, подождите...
</ng-template>

<form class="form form_crm" [formGroup]="formGroup" novalidate>
  <div class="row no-gutters gutters-2 mb-2">
    <div class="col-3">
      <app-material-select formControlName="status" [caption]="'Статус'">
        <option [value]="''">Все</option>
        @for (item of statuses; track item) {
          <option [value]="item.id">
            {{item.caption}}
          </option>
        }
      </app-material-select>
    </div>
    <div class="col-3">
      <app-material-select formControlName="category" [caption]="'Типы событий'">
        <option [value]="''">Все</option>
        @for (item of modification; track item) {
          <option [value]="item.id">
            {{item.caption}}
          </option>
        }
      </app-material-select>
    </div>
    <div class="col-6">
      <app-material-select formControlName="object" [caption]="'ЖК/корпус'">
        <option [value]="''">Все</option>
        @for (item of objects; track item) {
          <option [value]="item.id">
            {{item.caption}}
          </option>
        }
      </app-material-select>
    </div>
  </div>
</form>
<div class="material-datatable-wrapper">
  <div class="table-responsive">
    <table class="table table-striped datatable table-rwd">
      <thead app-data-table-head
        [sort]="sort"
        [columns]="columns"
        (sort_emmit)="onSortChange($event)">
      </thead>
      <tbody app-data-table-body
        (rowClick)="rowClick.emit($event)"
        [columns]="columns">
      </tbody>
    </table>
  </div>
  <app-datatable-pagination
    [current_page]="current_page"
    (change_page)="changePage($event)">
  </app-datatable-pagination>
</div>
<div class="row no-gutters mt-4 mb-3">
  <div class="col-12">
    <button class="mb-3 button" (click)="onAcceptChecked()">Принять выбранное</button>
    <button class="mb-3 button ml-2" (click)="onDenyChecked()">Отклонить выбранное</button>
    <button class="mb-3 button pull-right" (click)="onDenyAll()">
      @if (now_in_update_modifications !== true) {
        Отклонить все
      } @else {
        <i class="fa fa-spinner fa-spin"></i> пожалуйста, подождите...
      }
    </button>
    <button class="mb-3 button pull-right mr-2" (click)="onAcceptAll()">
      @if (now_in_update_modifications !== true) {
        Принять все
      } @else {
        <i class="fa fa-spinner fa-spin"></i> пожалуйста, подождите...
      }
    </button>
    <button class="mb-3 button pull-right mr-4" (click)="customAcceptShown.set(true)">
        По столбцам
    </button>
    <!--    <button (click)="saveForm()" type="button" class="button button_main pull-right">-->
    <!--      Готово-->
  <!--    </button>-->
</div>
</div>

<ng-template #checkTmpl let-row="row">
  @if (row.is_waiting) {
    <input class="checkbox ml-1" type="checkbox" value="{{row.id}}"
      [checked]="getCheck(row.id)" (click)="onCheck(row.id)">
  }
</ng-template>

<ng-template #checkHeadTmpl let-row="row">
  <input class="checkbox" type="checkbox" value="all" [checked]="check_all" (click)="onCheckAll()">
</ng-template>

<ng-template #modificationTmpl let-row="row">
  {{row.modification_caption}}
  @if (row.new_plan) {
    @if (!getView(row.id)) {
      <a href="javascript: void(0)" (click)="onView(row.id)">Показать</a>
    }
    @if (getView(row.id)) {
      <div class="images-preview images-preview_small mt-1 ml-1 mb-0 pull-right"
      (click)="displayImage(row.new_plan)" [style.background-image]="'url('+row.new_plan+')'"></div>
    }
  }
</ng-template>

@if (customAcceptShown() === true) {
  <app-modal
    [closeOutside]="false"
    [caption]="'Принять/Отклонить по столбцам:'"
    (onClosed)="customAcceptShown.set(false)"
  >
    @if (customAcceptData) {
<!--      <h4>Всего данных: {{customAcceptData['n']}}</h4>-->
      <div class="pb-3" [formGroup]="formGroupCustom">
        @for (row of customAcceptData['cols_on_waiting']; track row; let ind = $index) {
          <div class="mb-3">
            <app-material-input-radio-button [formControlName]="row['col_name']"
                                             [data]="types" [labelClass]="''"
            >{{row['col_name_fmt']}} ({{row['counts']}} шт. изменений)</app-material-input-radio-button>
          </div>
        }
        <div class="my-5">
          <button (click)="saveCustomAcceptForm()" type="button"
                  class="button button-primary" [disabled]="customAcceptLoading">
            @if (customAcceptLoading) {
              <i class="fa fa-spinner fa-spin"></i> Загрузка
            } @else {
              Обработать
            }
          </button>
        </div>
      </div>
    } @else {
      <div>
        <app-preloader></app-preloader>
      </div>
    }
<!--    <button (click)="customAcceptShown.set(false)" class="button button_sub" type="button">Закрыть</button>-->
  </app-modal>
}
